export const tableScheme = [
    {
        text: 'ID',
        widthDefault: 24,
        widthCompact: 24,
        isCenterHeader: false,
        isCenterContent: false,
    },
    {
        text: 'Фото',
        widthDefault: 13,
        widthCompact: 13,
        isCenterHeader: true,
        isCenterContent: false,
    },
    {
        text: 'Товар',
        widthDefault: 58,
        widthCompact: 42,
        isCenterHeader: true,
        isCenterContent: false,
    },
    {
        text: 'Габариты',
        widthDefault: 29,
        widthCompact: 26,
        isCenterHeader: true,
        isCenterContent: true,
    },
    {
        text: 'Вес',
        widthDefault: 13,
        widthCompact: 13,
        isCenterHeader: true,
        isCenterContent: true,

    },
    {
        text: 'Цена за шт',
        widthDefault: 23,
        widthCompact: 19,
        isCenterHeader: true,
        isCenterContent: true,

    },
    {
        text: 'Кол-во',
        widthDefault: 14,
        widthCompact: 12,
        isCenterHeader: true,
        isCenterContent: true,

    },
    {
        text: 'Сумма',
        widthDefault: 14,
        widthCompact: 14,
        isCenterHeader: true,
        isCenterContent: true,

    },
];


export const PDFcolumnsGap = 3;

export function getPDFTableSchemeOptionByTitle(title: string) {
    return tableScheme.find(option => {
        return option.text === title;
    });
}
